import React , { useEffect, useState } from 'react';
import './texto_LB.css';
import { useTranslation } from "react-i18next";

// import Recomendados_LB from '../container';
// import {  Recomendados_LB } from '../container';
import {  Recomendados_LB, NL_Disponible, Descarga_LB, Debate_LB } from '../../../container';

const Texto_LB = () => {
  const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
  const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <div class="LB_row1_tex">
        <div class="LB_texto">
        <p>
        {/* Los asuntos que trata en este espacio van desde economía y políticas públicas, progreso y creación de riqueza, hasta consejos para administrar exitosamente un negocio. Uno de los temas que aborda con frecuencia es el del rol primordial que tiene la libertad para el <b>desarrollo de la sociedad</b>. Ricardo B. Salinas la considera como la cualidad misma que nos hace humanos. En palabras del doctor Ulrich Wacker: "Es el derecho fundamental del hombre y tiene sus límites en la libertad del prójimo". En este libro se reúne una selección de algunas entradas publicadas en su blog, que ilustran su visión sobre este derecho así como su reflejo en la vida económica y política, en México y a nivel mundial. Asimismo, este libro muestra cómo la libertad ha sido fundamental en el crecimiento y expansión de Grupo Salinas, porque sólo en un entorno de libertades se puede generar prosperidad y bienestar.  </p> */}
        <b>{(t('header.text1'))}<br/>{(t('header.text12'))}<br/>
        </b></p>
        </div>

        <div class="nombre"><p>
        {(t('header.text13'))}
        </p>
        </div>

        <div class="LB_texto2">
        <p>
        {/* Los asuntos que trata en este espacio van desde economía y políticas públicas, progreso y creación de riqueza, hasta consejos para administrar exitosamente un negocio. Uno de los temas que aborda con frecuencia es el del rol primordial que tiene la libertad para el <b>desarrollo de la sociedad</b>. Ricardo B. Salinas la considera como la cualidad misma que nos hace humanos. En palabras del doctor Ulrich Wacker: "Es el derecho fundamental del hombre y tiene sus límites en la libertad del prójimo". En este libro se reúne una selección de algunas entradas publicadas en su blog, que ilustran su visión sobre este derecho así como su reflejo en la vida económica y política, en México y a nivel mundial. Asimismo, este libro muestra cómo la libertad ha sido fundamental en el crecimiento y expansión de Grupo Salinas, porque sólo en un entorno de libertades se puede generar prosperidad y bienestar.  </p> */}
        {(t('header.text14'))}<span class="amarillo">{(t('header.text15'))}</span>
        {(t('header.text16'))}<span class="amarillo">{(t('header.text16') + t('header.text17'))}</span>
        {(t('header.text18')) + " "}<span class="amarillo">{(t('header.text19'))}</span>
      
        {(t('header.text110'))}<br class="ocultal_br"/>{(t('header.text111'))}
        <span class="amarillo">{(t('header.text112'))}</span>
        {(t('header.text113'))}

        </p>
        </div>







        <Recomendados_LB />
        <NL_Disponible />
        {/* <Descarga_LB />
      <Debate_LB /> */}

        {/* <div class="NL_tit_recomiendan">
                <h1>{(t('header.recomiendan'))}</h1>
            </div>

         */}
    </div>
    
  )
}

export default Texto_LB
